export enum LocationType {
  ACCOUNT = "ACCOUNT",
  DEPOT = "DEPOT",
  CUSTOMER = "CUSTOMER",
  CUSTOM = "CUSTOM",
  RESOURCE = "RESOURCE",
  STOP = "STOP",
  UNDEFINED = "UNDEFINED"
}
